export const DEFAULT_VIEW_SETTINGS_OPTIONS = { maxChecked: 4 };
